import { render } from "./Typograph.vue?vue&type=template&id=a415f994&ts=true"
import script from "./Typograph.vue?vue&type=script&lang=ts"
export * from "./Typograph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__